import { handleActions } from 'redux-actions';

import { sendRequest, sendRequestFailure, updateStatus } from '../actions/actions';

export const Installation = handleActions(
	{
		[sendRequest](state, { payload: data }) {
			return {
				status: 'inprogress',
				installationPercent: 1,
				installationMessage: window.wizardData.strings.init_message
			};
		},

		[updateStatus](state, { payload: data }) {
			return {
				status: data.data.status,
				installationPercent: data.data.progress,
				installationMessage: data.data.message
			};
		},
		[sendRequestFailure](state, {}) {
			return {
				status: 'failed',
				installationPercent: 100,
				installationMessage: window.wizardData.strings.fail_title,
			};
		},
	},
	{
		status: 'default',
		installationPercent: 1,
		installationMessage: window.wizardData.strings.init_message
	}
);
